import { useEffect } from 'react';
import { startAuthPolling, stopAuthPolling } from '@/entities/auth/runtime';

export function AuthWatchEffect() {
  useEffect(() => {
    startAuthPolling();

    return () => {
      stopAuthPolling();
    };
  }, []);

  return null;
}
